import { ReactElement, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import endpoints from '../../config/endpoints';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';
import { Sidebar } from '../../layouts/Sidebar';
import MapModal from '../../layouts/Modal/MapModal';

const UserManage = () => {
  const { id: paramId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [item, setItem] = useState<any>();
  const [accesses, setAccesses] = useState([]);
  const [selectedAccesses, setSelectedAccesses] = useState([]);
  const [roles, setRoles] = useState([]);
  const [address, setAddress] = useState<any>({phoneNumber: '',
    text: '',
    postal: '',
    cityId: 0,
    provinceId: 0});

  const send = async (e) => {
    e.preventDefault();

    dispatch(setLoading(true));

    const formData = new FormData(e.target);

    const res = await restApi(endpoints.user.basic + (paramId || '')).post({
      name: formData.get('name'),
      lastName: formData.get('lastName'),
      nationalCode: formData.get('nationalCode'),
      phoneNumber: formData.get('phoneNumber'),
      password: formData.get('password'),
      email: formData.get('email'),
      bankCard: formData.get('bankCard'),
      roleId: formData.get('role'),
      status: formData.get('status'),
      username: formData.get('username'),
      address: {
        cityId: formData.get('addressCity'),
        provinceId: formData.get('addressProvince'),
        text: formData.get('addressText'),
        postalCode: formData.get('addressPostal'),
        phone: formData.get('addressPhone'),
      }
    });

    const result = await restApi(endpoints.user.access + res.data?.id).put({ accesses: selectedAccesses})

    if (res.code == 200) {
      Swal.fire({
        title: 'موفق',
        text: `کاربر با موفقیت ${paramId ? 'ویرایش' : 'ساخته'} شد`,
        icon: 'success',
        confirmButtonText: 'متوجه شدم',
        didClose() {
          navigate('/user')
        }
      });
    } else {
      Swal.fire({
        title: 'ناموفق',
        text: res?.data,
        icon: 'error',
        confirmButtonText: 'متوجه شدم'
      });
    }

    dispatch(setLoading(false));
  };

  const roleList = (data) => {
    const rows: ReactElement[] = [];

    data?.map(role => rows.push(
      <li className="spaceBetween">
        <label>{role.title}</label>
        <input type="checkbox" checked={selectedAccesses?.includes(role.id)} onClick={() => {
          if (selectedAccesses?.includes(role.id)) {
            setSelectedAccesses(prev => prev?.filter(e => e != role.id));
          } else {
            setSelectedAccesses(prev => ([...prev, role.id]))
          }
        }}/>
      </li>
    ))

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      restApi(endpoints.access.index).get(),
      restApi(endpoints.role.index).get(),
      paramId && restApi(endpoints.user.index + paramId).get(),
    ]);

    setAccesses(res[0].data);
    setRoles(res[1].data);

    if (paramId) {
      setItem(res[2].data);
      setAddress(res[2].data?.addresses);
      setSelectedAccesses(res[2].data?.accesses?.map(e => e.id));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <body className="dashboardBody">
      <Sidebar/>
      <main className="dashBoardMain main">
        <form onSubmit={send}>

        <div className="addInfoHeader">
          <button className="dashboardHeader keepRight clickable" type="submit" >
            ارسال
          </button>
          <span>
            <h1 className="sideBarTitle"> بازگشت به صفحه کاربران</h1>
             <h1 className="dashBoardTitle">ویرایش کاربر</h1>
          </span>
          <i className="backAdd clickable" onClick={() => navigate('/user/')}></i>
        </div>
        <section className="userInfo">
          <h1 className="dashBoardTitle">اطلاعات کاربر</h1>
          <div className="userInfoContainer width96">
            <div className="section30">
              <label className="sideBarTitle">کد ملی</label>
              <input className="editProductInput" defaultValue={item?.nationalCode} name="nationalCode"/>
              <label className="sideBarTitle">شماره کارت بانکی</label>
              <input className="editProductInput" defaultValue={item?.bankCard} name="bankCard"/>
              <label className="sideBarTitle">رمز عبور <small>(فقط در صورت نیاز به تغییر وارد کنید)</small></label>
              <input className="editProductInput" name="password"/>
              {/* <div> */}
              {/*   <div className="column"> */}
              {/*     <label className="sideBarTitle">وضعیت مشاهده قیمت</label> */}
              {/*     <span className="radioButtons"> */}
              {/*   <input className="smallInput" placeholder="0%" type="number" defaultValue={item?.specialPercent < 0 ? item?.specialPercent * -1 : item?.specialPercent} name="specialPercent"/> */}
              {/*     <span className="radioButtons"> */}
              {/*       <p>بالاتر</p> */}
              {/*         <i className={`${sign === 1 ? 'slectedradioButton' : 'radioButton'}`} onClick={() => setSign(1)}></i> */}
              {/*       <hr className="verLine"/> */}
              {/*       <p>پایین تر</p> */}
              {/*       <i className={`${sign === -1 ? 'slectedradioButton' : 'radioButton'}`} onClick={() => setSign(-1)}></i> */}
              {/*       </span> */}
              {/*         </span> */}
              {/*   </div> */}
              {/* </div> */}
            </div>
            <div className="section30">
              <label className="sideBarTitle">نام کاربری</label>
              <input className="editProductInput" defaultValue={item?.username} name="username"/>
              <label className="sideBarTitle">شماره تلفن</label>
              <input className="editProductInput" defaultValue={item?.phoneNumber} name="phoneNumber"/>
              <label className="sideBarTitle">ایمیل</label>
              <input className="editProductInput" defaultValue={item?.email} name="email"/>
            </div>
            <div className="section30">
              <label className="sideBarTitle">وضعیت</label>
              <select className="selector30"  defaultValue={item?.status} name="status" >
                <option value={0}>غیر فعال</option>
                <option value={1} selected={item?.status == 1}>فعال</option>
              </select>
              <label className="sideBarTitle">نقش کاربری</label>
              <select className="selector30" name="role" onChange={(input) => setSelectedAccesses(roles?.find(e => e.id == input.target.value)?.accesses?.map(e => e.id))}>
                {roles.map(e => <option selected={item?.roleId == e.id} value={e.id}>{e.title}</option>)}
              </select>
              <label className="sideBarTitle">نام</label>
              <input className="editProductInput" defaultValue={item?.name} name="name"/>
              <label className="sideBarTitle">نام خانوادگی</label>
              <input className="editProductInput" defaultValue={item?.lastName} name="lastName"/>
            </div>
          </div>
        </section>
        <section className="bottom">
          <h6 className="dashBoardTitle">آدرس ها</h6>
          <div className="bottomDiv">
            <span className="adressCard">
          <div className="addressCardRight">
            <span className="adressPin">
              <i className="mapPin"></i>
              <h6>{address?.title}</h6>
            </span>
             <p className="adressText marginZero">{address?.text}
               <br/>{address?.phoneNumber}</p>
          </div>
          <div className="addressImage">
          <img src="/img/map.jpg" className="mapPhoto"/>
        <span className="svgContainer">
            {/* <i className="trash"></i> */}
              <i className="edit clickable" onClick={() => setShowModal(true)}></i>
        </span>
            </div>
        </span>
            <div className={`formModal ${showModal ? 'flex' : ''}`}>
              <div className="modalOverLay" onClick={() => setShowModal(false)}>
              </div>
              <MapModal setShowModal={setShowModal} address={address} setAddress={setAddress}/>
            </div>
          </div>
        </section>
          {item?.roleId != 1 &&
          <section className="bottom width100">
            <h6 className="dashBoardTitle">سطح دسترسی ها</h6>
            <div className="userAccessContainer">
                <div className="userAccess">
                  <h3>منو ها</h3>
                  <ul>
                    {roleList(accesses.filter(e => e.category == "menu"))}
                  </ul>
                </div>
                <div className="userAccess">
                  <h3>سفارش</h3>
                  <ul>
                    {roleList(accesses.filter(e => e.category == "order"))}
                  </ul>
                </div>
                <div className="userAccess">
                  <h3>متفرقه</h3>
                  <ul>
                    {roleList(accesses.filter(e => e.category != "order" && e.category != "menu"))}
                  </ul>
                </div>
            </div>
          </section>
          }
        </form>
      </main>
      </body>
    </>
  );
};
export default UserManage;